import assign from 'object-assign';
import { EventEmitter } from 'events';
import { partition } from 'lodash';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'BULK_ADD_ACCESSORIALS_STORE_CHANGE';
let bulkAddResult = {
    success: false,
    successes: [],
    errors: [],
};
const BulkAddAccessorialsStore = assign({}, EventEmitter.prototype, {
    emitChange(ledgerType) {
        this.emit(CHANGE_EVENT, ledgerType);
    },
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    setErrorResult(result) {
        const { errors } = result;
        bulkAddResult = Object.assign(Object.assign({}, bulkAddResult), { success: false, inProgress: false, successes: [], errors });
        this.emitChange();
    },
    setSuccessResult(result) {
        const { successes, errors } = result;
        bulkAddResult = Object.assign(Object.assign({}, bulkAddResult), { success: true, inProgress: false, successes,
            errors });
        this.emitChange();
    },
    setAccessorialRequestErrorResult(result) {
        const { failures } = result;
        bulkAddResult = Object.assign(Object.assign({}, bulkAddResult), { success: false, inProgress: false, successes: [], errors: failures.map((acc) => acc.shipment._id || acc.shipment) });
    },
    setAccessorialRequestSuccessResult(result) {
        let { successes, failures } = result;
        if (successes.some((item) => item.autodeclined && item.carrier_decline_reason_code)) {
            const [toFailures, toSuccesses] = partition(successes, (item) => item.autodeclined && item.carrier_decline_reason_code);
            failures = [...failures, ...toFailures];
            successes = toSuccesses;
        }
        bulkAddResult = Object.assign(Object.assign({}, bulkAddResult), { success: successes ? successes.length > 0 : false, inProgress: false, successes: successes.map((acc) => acc.shipment._id || acc.shipment), errors: failures
                ? failures.map((acc) => {
                    return {
                        accessorial_type: acc.accessorial_type,
                        errMessage: acc.carrier_decline_reason_code,
                    };
                })
                : [] });
        this.emitChange();
    },
    getBulkAddResult() {
        return bulkAddResult;
    },
});
BulkAddAccessorialsStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    const action = payload.action;
    switch (action.type) {
        case ActionTypes.BULK_ADD_ACCESSORIALS_SUCCESS:
            BulkAddAccessorialsStore.setSuccessResult(action.result);
            break;
        case ActionTypes.BULK_ADD_ACCESSORIALS_FAIL:
            BulkAddAccessorialsStore.setErrorResult(action.result);
            break;
        case ActionTypes.BULK_CREATE_ACCESSORIAL_REQUEST_SUCCESS:
            BulkAddAccessorialsStore.setAccessorialRequestSuccessResult(action.result);
            break;
        case ActionTypes.BULK_CREATE_ACCESSORIAL_REQUEST_FAIL:
            BulkAddAccessorialsStore.setAccessorialRequestErrorResult(action.err.entity.result);
            break;
        default:
            break;
    }
});
export default BulkAddAccessorialsStore;
